import { MatDialogConfig } from "@angular/material/dialog";
import { ConfirmDialogData } from "../../../shared/dialogs/confirm-dialog/confirm-dialog.component";

export const DELETE_ACTION_PLAN_DIALOG_CONFIG: MatDialogConfig<ConfirmDialogData> =
  {
    data: {
      title: "Delete action plan",
      message: "Do you want to delete this Action Plan?",
      inputForm: [],
    },
  };
